import {
  createBeneficiaryBankRoutingCodeSchema,
  getBeneficiaryBankFormConfig,
} from '@peanuds/shared';

import type { RecipientEntrySchemeDefinition } from '../../recipient-entry.types';

export const swiftRecipientEntryScheme: RecipientEntrySchemeDefinition = {
  id: 'swift',
  config: getBeneficiaryBankFormConfig('swift'),
  createRoutingCodeSchema: () => createBeneficiaryBankRoutingCodeSchema('swift'),
  toRoutingCodes: (routingCode) => {
    if (routingCode.length === 0) {
      return {} as Record<string, string>;
    }

    return { bic: routingCode };
  },
};
